import { useNavigate } from 'react-router'

import { LISTING_PROFILE_EDIT_BLOCK } from '../../RentalPortalListingProfile.constants'
import {
  getListingApplicantsTabUrl,
  getListingPublishingsTabUrl,
} from '../../RentalPortalListingProfile.utils'
import { useListingProfileContext } from '../useListingProfileContext'
import { useListingProfileEditBlockOpener } from '../useListingProfileEditBlockOpener'
import { useListingProfilePhotoEditorOpener } from '../useListingProfilePhotoEditorOpener'

import { LISTING_ATTENTION_DESTINATION } from './useListingProfileAttentionAction.constants'
import {
  getIsListingAttentionDestinationPublishing,
  getListingAttentionActionState,
} from './useListingProfileAttentionAction.utils'

export function useListingProfileAttentionAction() {
  const navigate = useNavigate()

  const { handleOpenResponsibleManagerModal, listingData } =
    useListingProfileContext()

  const { handleOpenEditBlock } = useListingProfileEditBlockOpener()

  const {
    canEditPhotos,
    handleOpenPhotoEditor,
    isPhotoEditorOpen,
    photoEditorProps,
  } = useListingProfilePhotoEditorOpener()

  const primaryAction = listingData?.attention?.primary_action

  const { destination, isDisabled } = getListingAttentionActionState({
    canEditPhotos,
    listing: listingData,
  })

  function handleRequestDescriptionEdit() {
    handleOpenEditBlock(LISTING_PROFILE_EDIT_BLOCK.description)
  }

  function handleRequestKeyFactsEdit() {
    handleOpenEditBlock(LISTING_PROFILE_EDIT_BLOCK.keyFacts)
  }

  function handleOpenPublishings() {
    navigate(getListingPublishingsTabUrl(listingData?.id))
  }

  function handleOpenApplicants() {
    navigate(getListingApplicantsTabUrl(listingData?.id))
  }

  const destinationHandlers = {
    [LISTING_ATTENTION_DESTINATION.applicants]: handleOpenApplicants,
    [LISTING_ATTENTION_DESTINATION.descriptionEdit]:
      handleRequestDescriptionEdit,
    [LISTING_ATTENTION_DESTINATION.keyFactsEdit]: handleRequestKeyFactsEdit,
    [LISTING_ATTENTION_DESTINATION.managerEdit]:
      handleOpenResponsibleManagerModal,
    [LISTING_ATTENTION_DESTINATION.photoEditor]: handleOpenPhotoEditor,
    [LISTING_ATTENTION_DESTINATION.publishing]: handleOpenPublishings,
  }

  return {
    handleClickAction: destinationHandlers[destination],
    isActionDisabled: isDisabled,
    isActionFullPageOnly:
      getIsListingAttentionDestinationPublishing(destination),
    isPhotoEditorOpen,
    photoEditorProps,
    primaryAction,
  }
}
